<template>
  <el-scrollbar wrapClass="scrollbar-wrapper">
    <div class="" v-bind:class="{collapse: isCollapse}">
      <el-menu
        :collapse="isCollapse"
      >
        <sidebar-item :pages="this.$store.getters.getPages"></sidebar-item>
      </el-menu>
    </div>
  </el-scrollbar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: {SidebarItem},
  data () {
    return {
      // collapseMenuClass: this.isCollapse() ? 'is-collapse' : 'is-not-collapse',
      backgroundColor: '#e6e8ec'
    }
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    isCollapse () {
      return !this.sidebar.opened
    },
    hoverBackground () {
      return this.backgroundColor ? this.mixColor(this.backgroundColor, 0.2) : ''
    }
  }
}
</script>
<style>
  .sidebar-border {
    border-right: 1px solid #d9dadc;
  }

  /*.is-not-collapse {*/
    /*width: 180px !important;*/
  /*}*/
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue